// src/lib/chartRange.js — where the Stats chart's time axis starts.
//
// The axis used to start at the stored anchor (goalSaved.planAnchorDate).
// A plan carries restored past weeks from earlier plans
// (server/services/planHistory.js) that can start well before that anchor,
// and several paths reset the anchor to the current week — so the chart cut
// off history that was loaded and counted (adherence, plan-vs-actual).
//
// The axis therefore starts at the EARLIER of the stored anchor and the
// plan's own first week. The Week-N counter keeps using the anchor, so it
// does not jump when history is restored.
//
// CommonJS + no object spread (CRA consumes it via module.exports).

/** Monday 00:00 (local) of the week containing `ms`. */
function weekStartMs(ms) {
  const d = new Date(Number(ms));
  if (isNaN(+d)) return null;
  d.setHours(0, 0, 0, 0);
  const dow = d.getDay();
  d.setDate(d.getDate() + (dow === 0 ? -6 : 1 - dow));
  return +d;
}

/** Local midnight of a 'YYYY-MM-DD' date (never UTC-parsed). */
function localDateMs(iso) {
  const p = String(iso || '').slice(0, 10).split('-').map(Number);
  if (p.length !== 3 || p.some(function (n) { return !Number.isFinite(n); })) return null;
  const d = new Date(p[0], p[1] - 1, p[2]);
  return isNaN(+d) ? null : +d;
}

/**
 * @param {number} anchorMs            goalSaved.planAnchorDate
 * @param {string} planFirstSessionDate first session date of the plan's first week
 * @returns {number|null} ms of the week the axis starts at
 */
function chartStartMs(anchorMs, planFirstSessionDate) {
  const anchorWeek = weekStartMs(anchorMs);
  const planMs = localDateMs(planFirstSessionDate);
  const planWeek = planMs != null ? weekStartMs(planMs) : null;
  if (anchorWeek == null) return planWeek;
  if (planWeek == null) return anchorWeek;
  return Math.min(anchorWeek, planWeek);
}

module.exports = { weekStartMs, localDateMs, chartStartMs };
